import { BaseModel } from "./base-model";
import { Rs6UpdateInfo } from "../services/rs6-service";

export abstract class VesselRs6ModelBase extends BaseModel {
    abstract getUpdateInfo(): Promise<Map<string, Rs6UpdateInfo>>;
    abstract get latestUpdateDate(): string | null;
}

let VesselRs6Model: VesselRs6ModelBase|null = null;

function setVesselRs6ModelModel(model: VesselRs6ModelBase) {
    VesselRs6Model = model;
}

export { VesselRs6Model, setVesselRs6ModelModel };